import $ from "jquery"
import AcademicTitles from "lib/academic_titles"

import BasePage from "pages/base_page"
import autocomplete from "lib/autocomplete"

export default class ProfileCredentialsPage extends BasePage {
  initialize(options) {
    super.initialize(options)

    return this.initAutoComplete()
  }

  initAutoComplete() {
    autocomplete($(".research-code.autocomplete"), {
      source: "/field_of_researches.json",
      minLength: 2,
      autoFocus: true,
      delay: 200,
      select(event, ui) {
        event.preventDefault()
        return $(this).val(ui.item.code)
      },
    })

    autocomplete($(".funding-source.autocomplete"), {
      source: "/funding_sources.json",
      minLength: 2,
      autoFocus: true,
      delay: 200,
      select(event, ui) {
        event.preventDefault()
        return $(this).val(ui.item.label)
      },
    })

    autocomplete($(".credential-title.autocomplete"), {
      source: AcademicTitles.list,
      minLength: 2,
      autoFocus: true,
      delay: 200,
      select(event, ui) {
        return this.val(ui.item)
      },
    })

    return autocomplete($(".professional-membership.autocomplete"), {
      source: "/professional_memberships.json",
      select(event, ui) {
        event.preventDefault()
        return $(this).val(ui.item.label)
      },
    })
  }
}
